import { makeStyles } from "@material-ui/core";

const usePageHeaderStyles = makeStyles(theme => ({
    label: {
        fontSize: "0.8rem"
    },
    radioRoot: {
        color: "#354052e6 !important",
    }
}))

export default usePageHeaderStyles;